import MenuOptions from "../../components/order/menu/MenuOptions";

export default function PointRewardMenu({ order, mobile, onDelete, onEdit }) {
  const menu = [
    {
      label: "Edit reward",
      action: () => {
        onEdit?.();
      },
      visible: true,
    },
    {
      label: "Delete reward",
      action: () => {
        onDelete?.();
      },
      visible: true,
    },
  ];

  return (
    <>
      <div className="hidden"></div>
      <MenuOptions mobile={mobile} menu={menu} />
    </>
  );
}
// Stay menu
